import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "./index";
import * as UserModel from "@/models/user";

export interface UserState {
  lang: string;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "user",
})
class User extends VuexModule implements UserState {
  lang = "es";
  cognitoUser = undefined;
  currentUser: UserModel.default = new UserModel.default();

  get getLang() {
    return this.lang;
  }

  get getCognitoUser() {
    return this.cognitoUser;
  }

  get getCurrentUser() {
    return this.currentUser;
  }

  get isAdmin() {
    return this.currentUser.role.indexOf("admin") !== -1;
  }

  @Mutation
  setLang(lang: string) {
    this.lang = lang;
  }

  @Mutation
  setCognitoUser(user: any) {
    this.cognitoUser = user;
  }

  @Mutation
  setCurrentUser(user: UserModel.default) {
    this.currentUser = new UserModel.default(user);
  }
}

export const UserModule = getModule(User);
